import { createFileRoute } from '@tanstack/react-router'
import { AdminOnlineOrders } from '@/components/admin/AdminOnlineOrders'
import {
  OnlineOrderingGateSkeleton,
  OnlineOrderingPaywall,
} from '@/components/admin/OnlineOrderingPaywall'
import { useOnlineOrderingEnabled } from '@/hooks/useOnlineOrderingEnabled'

// Premium gate at the route level: on locked tenants AdminOnlineOrders never
// mounts, so its 15s polling query, SSE stream, and nag-ring sound never run.
function OnlineOrdersRoute() {
  const { enabled, isLoading, isError } = useOnlineOrderingEnabled()
  // E-P3: on a settings-load failure, show a retry — never hang on the skeleton
  // (the old behaviour) or flash the paywall to a paying tenant.
  if (isError)
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 p-8 text-center">
        <p className="text-sm text-muted-foreground">
          Couldn’t load settings. Check your connection and try again.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md border px-4 py-2 text-sm font-medium hover:bg-muted"
        >
          Retry
        </button>
      </div>
    )
  if (isLoading) return <OnlineOrderingGateSkeleton />
  if (!enabled) return <OnlineOrderingPaywall />
  return <AdminOnlineOrders />
}

export const Route = createFileRoute('/admin/online-orders')({
  component: OnlineOrdersRoute,
})
